// @ts-nocheck

import React from "react";
import { Tree } from "react-arborist";

import { Role } from "@contractool/schema";

import { Node } from "./Node";
import { normalizeSearchText } from "../../../utils/search";

interface Props {
  roles: Role[];
  search: string;
  supplierFields: {
    name: string;
    label: string;
  };
  supplierPOCFields: {
    name: string;
    label: string;
  };
}

const Roles: React.FC<Props> = ({
  roles,
  search,
  supplierFields,
  supplierPOCFields,
}) => {
  let data = roles.map((role: Role) => {
    return {
      id: role.key,
      name: role.label,
      children: [
        {
          id: role.full_key + ".name",
          name: "Name",
          key: role.full_key + ".name",
        },
        {
          id: role.full_key + ".fields.gender",
          name: "Gender",
          key: role.full_key + ".fields.gender",
        },
      ],
      key: role.full_key,
    };
  });

  data = [
    ...data,
    {
      id: "supplier",
      name: "Suppliers",
      children: [
        {
          id: "supplier.title",
          name: "Title",
          key: "supplier.title",
        },
        {
          id: "supplier.address_city",
          name: "City",
          key: "project.supplier.address_city",
        },
        {
          id: "supplier.address_street",
          name: "Street",
          key: "supplier.address_street",
        },
        {
          id: "supplier.address_state",
          name: "State",
          key: "supplier.address_state",
        },
        {
          id: "supplier.address_zip",
          name: "Zip",
          key: "supplier.address_zip",
        },
        ...supplierFields,
      ],
      key: "supplier",
    },
    {
      id: "supplierPOC",
      name: "Supplier POC",
      children: [
        {
          id: "supplierContact.name",
          name: "Name",
          key: "supplierContact.name",
        },
        {
          id: "supplierContact.email",
          name: "Email",
          key: "supplierContact.email",
        },
        ...supplierPOCFields,
      ],
      key: "supplierPOC",
    },
  ];

  // @ts-ignore
  return (
    <Tree
      initialData={data}
      openByDefault={false}
      rowHeight={40}
      searchMatch={(node, term) =>
        normalizeSearchText(node.data.name).includes(normalizeSearchText(term))
      }
      searchTerm={search}
    >
      {Node}
    </Tree>
  );
};

export default Roles;
